<template>
  <a
    :class="`site__footer-logo ${profile.site_hide_branding ? 'sr-only' : ''}`"
    :href="campsiteUrl"
    target="_blank"
    aria-label="Campsite.bio"
    @click.prevent="handleClick"
  >
    <Logo />
  </a>
</template>

<script>
import Logo from '@/components/logo';
import { computed, useContext } from '@nuxtjs/composition-api';
import { useWindowSize } from '@vueuse/core';

export default {
  components: {
    Logo,
  },

  setup() {
    const { store } = useContext();
    const { width } = useWindowSize();

    const profile = computed(() => {
      return store.state.campsite;
    });

    const username = computed(() => {
      return encodeURIComponent(profile.value.username_lowercase);
    });

    const campsiteUrl = computed(() => {
      let referrer = '';
      if (process.client && document.referrer) {
        try {
          referrer = new URL(document.referrer).hostname;
          // eslint-disable-next-line no-empty
        } catch (e) {}
      }
      // eslint-disable-next-line no-unused-vars
      const windowWidth = width.value;
      return `https://campsite.bio?ref=${username.value}&referrer=${referrer}`;
    });

    function handleClick() {
      window.open(campsiteUrl.value, '_blank');
    }

    return {
      campsiteUrl,
      profile,
      handleClick,
    };
  },
};
</script>

<style lang="scss">
.site__footer-logo {
  align-items: center;
  color: var(--p-text-color);
  display: inline-flex;
  padding: 3px 6px;
  text-decoration: none;

  &:hover,
  &:focus {
    color: var(--p-text-color);
  }
}

.path-1 {
  fill: var(--p-logo-fill);
}

.path-2 {
  fill: var(--p-logo-fill-2);
}
</style>
